import { useMemo } from "react";
import {
  FinancialGoal,
  useListAndSearchAllFinancialGoals,
} from "@rentablo/api/apiv1";

const defaultFirstThenOldest = (a: FinancialGoal, b: FinancialGoal) =>
  Number(Boolean(b.isDefault)) - Number(Boolean(a.isDefault)) ||
  (a.id ?? 0) - (b.id ?? 0);

export const useGoals = () => {
  const { data, ...query } = useListAndSearchAllFinancialGoals();

  const goals = useMemo(
    () => [...(data?.financialGoals ?? [])].sort(defaultFirstThenOldest),
    [data]
  );

  return { ...query, goals };
};
